// ==============================
// IMPORT NODE MODULES
// ==============================

import Vue from "vue"
import Vuex from "vuex"

// ==============================
// VUEX SETUP
// ==============================

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        timeOut: 900,
        sessioneScaduta: false,
        indirizzo: "https://rapi.emmedata.com",
        lingua: localStorage.getItem("RMA_LANGUAGE") || "ITL",
        sessione: { mail: "", ordine: 0, access_token: "", refresh_token: "" },
        objLingua: [
            { val: "ITL", ico: "ITL.ico", desc: "Italiano" },
            { val: "ENG", ico: "ENG.ico ", desc: "Inglese" },
        ],
    },

    mutations: {
        setSessione(state, datiSessione) {
            state.sessione.mail = datiSessione.mail
            state.sessione.ordine = datiSessione.ordine
            state.sessione.accessToken = datiSessione.accessToken
            state.sessione.refreshToken = datiSessione.refreshToken
            state.sessioneScaduta = false
        },
        setLingua(state, chgLingua) {
            state.lingua = chgLingua
        },
        setIndirizzo(state, chgIndirizzo) {
            state.indirizzo = chgIndirizzo
        },
        setSessioneScaduta(state) {
            state.sessioneScaduta = true
        },
    },
})

// ==============================
//  EXPORT STORE
// ==============================

export default store
